export default {
      id: "tt-align-center-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.0b648a3c.svg#tt-align-center",
      toString: function () {
        return this.url;
      }
    }